import { Controller } from "@hotwired/stimulus";

// Usage: data-controller="file-preview" data-file-preview-file-url-value="..." data-file-preview-file-type-value="..."
export default class extends Controller {
  static values = {
    fileUrl: String,
    fileType: String
  }

  onClick(event) {
    event.preventDefault();
    const url = this.fileUrlValue;
    const type = this.fileTypeValue.toLowerCase();
    if (!url) return;

    if (["pdf", "png", "jpg", "jpeg", "gif", "bmp", "webp", "svg"].includes(type)) {
      window.open(url, "_blank");
    } else {
      // For other files (including doc/docx), trigger download
      const a = document.createElement("a");
      a.href = url;
      a.download = "";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }
}
